(function () {
    $(document).on("click", "[data-custom-atc]", async function (e) {
        e.preventDefault();
        const id = $(this).attr("data-id");
        const $button = $(this);

        //Start loading
        $button.addClass("loading");
        $button.find(".loading-overlay__spinner").removeClass("hidden");

        const prev = await getItems();
        const alreadyAdded = prev.items.filter(
            (lineItem) => lineItem.variant_id == id
        )?.[0] || null;
        const addedQty = alreadyAdded && alreadyAdded.quantity ? alreadyAdded.quantity : 0;
        if (addedQty == 0) {
            await addItem(id, 1);
            window.location.href = "/checkout";
            return;
        }
        if (addedQty == 1) {
            window.location.href = "/checkout";
            return;
        }
        await removeItems(id);
        await addItem(id, 1);
        return (window.location.href = "/checkout");
    });
    async function addItem(id, qty) {
        try {
            return await $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    id: id,
                    quantity: 1,
                },
                dataType: "json",
            });
        } catch (error) {
            console.log(error);
            $("[data-custom-atc]").removeClass("loading");
            $("[data-custom-atc]")
                .find(".loading-overlay__spinner")
                .addClass("hidden");
        }
    }
    async function getItems() {
        return await $.ajax({
            url: "/cart.js",
            dataType: "json",
        });
    }
    async function removeItems(id) {
        const updates = {};
        updates[id] = 0;
        try {
            return await $.ajax({
                type: "POST",
                url: "/cart/update.js",
                data: { updates },
                dataType: "json",
            });
        } catch (error) {
            console.log(error);
            $("[data-custom-atc]").removeClass("loading");
            $("[data-custom-atc]")
                .find(".loading-overlay__spinner")
                .addClass("hidden");
        }
    }
})();
$(document).ready(function () {
    $(".header__icon--menu .hamburger").click(function () {
        $(".section-header, body").addClass("menu-open");
    });
    $(".mb-menu-cross .cross").click(function () {
        $(".section-header, body").removeClass("menu-open");
    });

    // =================  Feature Product Variant Selection ==================
    $("#card_product_variants").change(function () {
        let parent$ = $(this).closest(".card--standard");
        let variantId = $(this).val();
        let isAvailable = $(this).find("option:selected").data("available");
        if (isAvailable) {
            parent$.find(".selected_variant").val($(this).val());
            parent$.find(".quick-add__submit").attr("disabled", false);
            parent$.find(".sold-out-message").addClass("hidden");
            parent$.find(".add-to-cart-message").removeClass("hidden");
            parent$.find(".sold-out-badge").addClass("hidden");
        } else {
            parent$.find(".sold-out-badge").removeClass("hidden");
            parent$.find(".selected_variant").val("");
            parent$.find(".quick-add__submit").attr("disabled", true);
            parent$.find(".sold-out-message").removeClass("hidden");
            parent$.find(".add-to-cart-message").addClass("hidden");
        }
    });


    var countdownElement = $("[data-countdown]");
    var interval;

    function updateCountdown() {
        var finalDate = countdownElement.data("countdown");
        var remainingTime = moment
            .tz(finalDate, "America/Los_Angeles")
            .diff(moment());

        if (remainingTime <= 0) {
            // Countdown has ended
            clearInterval(interval);
            countdownElement.html("Early access expired");
        } else if (remainingTime <= 600000) {
            // Less than or equal to 10 minutes remaining
            countdownElement.removeClass("hidden");
            countdownElement.countdown(
                moment.tz(finalDate, "America/Los_Angeles").toDate(),
                function (event) {
                    countdownElement.html(
                        event.strftime("<div class='timerOuterContainer'><p>early access expires in</p><div class='timerInnerContainer'><div class='timerCellDays'> %D   <span>days</span> </div><div class='timerCellHours'> %H    <span>hrs</span> </div><div class='timerCell'> %M   <span>mins</span> </div> <div class='timerCell'> %S    <span>sec</span> </div> </div></div>")
                    );
                }
            );
        } else {
            // More than 10 minutes remaining
            countdownElement.addClass("hidden");
        }
    }

    // Initial update
    updateCountdown();

    // Update the countdown every second
    interval = setInterval(updateCountdown, 1000);

});









// Script super básico para probar que los console.log funcionan

// Script para filtrar thumbnails por color con depuración mejorada
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM cargado, inicializando script de filtrado de thumbnails');
    
    // Seleccionar todas las secciones de featured product
    const featuredProductSections = document.querySelectorAll('.section-featured-product');
    console.log('Secciones de featured product encontradas:', featuredProductSections.length);
    
    // Para cada sección de featured product
    featuredProductSections.forEach(function(section, sectionIndex) {
      console.log('Inicializando sección:', sectionIndex, section.classList.toString());
      
      // Función para filtrar thumbnails según el color seleccionado
      function filterThumbnailsByColor(selectedColor) {
        // Si no hay un color seleccionado, salir
        if (!selectedColor) {
          console.log('No hay color seleccionado, saliendo');
          return;
        }
        
        // Normalizar el color a minúsculas
        selectedColor = selectedColor.toLowerCase();
        console.log('Filtrando por color:', selectedColor, 'en sección:', sectionIndex);
        
        // Encontrar todos los thumbnails en esta sección
        const thumbnails = section.querySelectorAll('.thumbnail-list__item');
        console.log('Thumbnails encontrados:', thumbnails.length);
        
        // Quitar la clase hide-thumb de todos y luego aplicarla según corresponda
        thumbnails.forEach(function(thumbnail, index) {
          thumbnail.classList.remove('hide-thumb');
          
          const thumbnailColor = (thumbnail.getAttribute('data-color') || '').toLowerCase();
          console.log(`Thumbnail ${index}: Color=${thumbnailColor}, SelectedColor=${selectedColor}`);
          
          // Si el thumbnail tiene color y no es el seleccionado, ocultarlo
          if (thumbnailColor && thumbnailColor !== selectedColor) {
            console.log(`  - Ocultando thumbnail ${index} (${thumbnailColor})`);
            thumbnail.classList.add('hide-thumb');
          } else {
            console.log(`  - Mostrando thumbnail ${index} (${thumbnailColor || 'sin color'})`);
          }
        });
        
        // Aplicar el mismo filtro a las imágenes principales
        const sliderItems = section.querySelectorAll('.product__media-item');
        console.log('Elementos del slider encontrados:', sliderItems.length);
        
        sliderItems.forEach(function(item, index) {
          item.classList.remove('hide-thumb');
          
          const itemColor = (item.getAttribute('data-color') || '').toLowerCase();
          console.log(`Slider ${index}: Color=${itemColor}, SelectedColor=${selectedColor}`);
          
          if (itemColor && itemColor !== selectedColor) {
            console.log(`  - Ocultando slider ${index} (${itemColor})`);
            item.classList.add('hide-thumb');
          } else {
            console.log(`  - Mostrando slider ${index} (${itemColor || 'sin color'})`);
          }
        });
      }
      
      // Filtrar inicialmente con el color seleccionado
      const initialColorInput = section.querySelector('.option-color input.product-variant-selector:checked');
      if (initialColorInput) {
        console.log('Color inicial seleccionado:', initialColorInput.value);
        filterThumbnailsByColor(initialColorInput.value);
      } else {
        console.log('No se encontró color inicial seleccionado');
      }
      
      // Agregar event listeners a todos los radio buttons de color
      const colorInputs = section.querySelectorAll('.option-color input.product-variant-selector');
      console.log('Inputs de color encontrados:', colorInputs.length);
      
      colorInputs.forEach(function(input, index) {
        console.log(`Configurando listener para input ${index}: value=${input.value}, checked=${input.checked}`);
        
        // Eliminar listeners previos para evitar duplicados
        input.removeEventListener('change', changeHandler);
        
        // Definir el manejador de eventos
        function changeHandler() {
          console.log(`Cambio detectado en input ${index}: ${input.value}, checked=${input.checked}`);
          if (input.checked) {
            filterThumbnailsByColor(input.value);
          }
        }
        
        // Añadir el listener
        input.addEventListener('change', changeHandler);
        console.log(`Listener añadido al input ${index}`);
      });
    });
  });
  
  // Agregar estilos CSS para ocultar los elementos con la clase hide-thumb
  const style = document.createElement('style');
  style.textContent = `
    .hide-thumb {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
  
  // Función auxiliar para verificar cambios en los inputs después de cargarse la página
  setTimeout(function() {
    console.log('Verificando estado de inputs después de 2 segundos:');
    document.querySelectorAll('.option-color input.product-variant-selector').forEach(function(input, index) {
      console.log(`Input ${index}: value=${input.value}, checked=${input.checked}`);
    });
  }, 2000);